import React,{ useState,useEffect } from "react";
import { useTranslation } from 'react-i18next';
import getTranslation from '../../utils/getTranslation';
import './styles.scss';
import { Container, Row, Col } from "react-bootstrap";
import { getPage } from "../../actions/mixedmode";
import { useDispatch, useSelector } from "react-redux"
import { useHistory } from "react-router";
const Page = () => {

   const { i18n } = useTranslation();
   const dispatch = useDispatch();
   const history = useHistory()
   const { pageinfo } = useSelector(state => state.mixedmode)
  useEffect(() => {
     dispatch(getPage(3))
   }, [])

    return (
       <div>
            <div className="ps-breadcrumb"><div className="container"><div className="ps-container"><ul className="breadcrumb"><li><a href="#" onClick={()=> history.push('/')}>Accueil</a></li><li>CGV </li></ul></div></div></div>
        <div className="quisommesnous" >

            <Container>
                <Row>
                    <Col className="mx-auto my-5" lg="12">

                       <h1 class="text-center mb-5"> {getTranslation(pageinfo?.titre, i18n.language)} </h1>
                        <span class="section-separator"></span>
<br/><br/>


                                     <div dangerouslySetInnerHTML={{ __html: getTranslation(pageinfo?.contenu, i18n.language) }}></div>


 
                    </Col>
                </Row>
            </Container>
        </div>
 
    </div>
    );
}

export default Page;